type PermutiveScript = {
    authors: string[];
    brand: string;
    keywords: string[];
    section: string;
    subtitle: string;
    tags: string[];
    isSIMX: boolean;
};

export function getPermutiveScript({
    authors,
    brand,
    keywords,
    section,
    subtitle,
    tags,
    isSIMX,
  }: PermutiveScript) {
  const workspaceId = isSIMX ? 'db98341e-60fd-4a55-a2a2-9cdc1d6cb3f8' : 'ad491600-d805-4a2c-870f-efe057881bc2';
  const apiKey = isSIMX ? 'c98a8c3e-cc66-490c-8564-256d59435d1a' : 'd806434b-51a0-4810-8e08-fe5dcb97a94e';
  const authorsProp = authors?.length ? `authors: ${JSON.stringify(authors)},` : '';
  const brandProp = brand ? `brand: "${brand}",` : '';
  const keywordsProp = keywords?.length ? `keywords: ${JSON.stringify(keywords)},` : '';
  const sectionProp = section ? `section: "${section}",` : '';
  const subtitleProp = subtitle ? `subtitle: "${subtitle}",` : '';
  const tagsProp = tags?.length ? `tags: ${JSON.stringify(tags)}` : '';

  // eslint-disable-next-line prefer-template,no-nested-ternary
  const article = `{${authorsProp}${brandProp}${keywordsProp}${sectionProp}${subtitleProp}${tagsProp}}`;

  const page = isSIMX ? `{ article: ${article} }` : '{}';

  return `!function(e,o,n,i){if(!e){e=e||{},window.permutive=e,e.q=[];var t=function(){return([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g,function(e){return(e^(window.crypto||window.msCrypto).getRandomValues(new Uint8Array(1))[0]&15>>e/4).toString(16)})};e.config=i||{},e.config.apiKey=o,e.config.workspaceId=n,e.config.environment=e.config.environment||"production",(window.crypto||window.msCrypto)&&(e.config.viewId=t());for(var g=["addon","identify","track","trigger","query","segment","segments","ready","on","once","user","consent"],r=0;r<g.length;r++){var w=g[r];e[w]=function(o){return function(){var n=Array.prototype.slice.call(arguments,0);e.q.push({functionName:o,arguments:n})}}(w)}}}(window.permutive,"${apiKey}","${workspaceId}",{"consentRequired": false});
    window.googletag=window.googletag||{},window.googletag.cmd=window.googletag.cmd||[],window.googletag.cmd.push(function(){if(0===window.googletag.pubads().getTargeting("permutive").length){var e=window.localStorage.getItem("_pdfps");window.googletag.pubads().setTargeting("permutive",e?JSON.parse(e):[]);var o=window.localStorage.getItem("permutive-id");o&&(window.googletag.pubads().setTargeting("puid",o),window.googletag.pubads().setTargeting("ptime",Date.now().toString())),window.permutive.config.viewId&&window.googletag.pubads().setTargeting("prmtvvid",window.permutive.config.viewId),window.permutive.config.workspaceId&&window.googletag.pubads().setTargeting("prmtvwid",window.permutive.config.workspaceId)}});
    permutive.addon('web',{
      "page": ${page}
    });`;
}
